module.exports = __webpack_public_path__ + "static/img/yixiInternational.5b97df15.png";